export interface RankItem {
  id: string;
  rank: number;
  name: string;
  category: string;
  price: string;
  score: number;
  trend: "up" | "down" | "flat";
  comment: string;
}

export const rankings: RankItem[] = [
  {
    id: "rk1",
    rank: 1,
    name: "老巷馄饨摊",
    category: "面食小吃",
    price: "¥15",
    score: 4.9,
    trend: "up",
    comment: "连续三个月稳居榜首，出摊两小时即售罄。",
  },
  {
    id: "rk2",
    rank: 2,
    name: "二楼烧腊档",
    category: "粤菜烧腊",
    price: "¥45",
    score: 4.8,
    trend: "flat",
    comment: "叉烧口碑稳定，午市排队体验略扣分。",
  },
  {
    id: "rk3",
    rank: 3,
    name: "奶油小方烘焙室",
    category: "甜品烘焙",
    price: "¥38",
    score: 4.7,
    trend: "up",
    comment: "盐可颂复购率高，上新日需趁早。",
  },
  {
    id: "rk4",
    rank: 4,
    name: "炭火三兄弟烧烤",
    category: "烧烤夜宵",
    price: "¥60",
    score: 4.6,
    trend: "down",
    comment: "羊肉串依旧出色，等位时间偏长。",
  },
  {
    id: "rk5",
    rank: 5,
    name: "手工竹升面馆",
    category: "面食小吃",
    price: "¥28",
    score: 4.5,
    trend: "flat",
    comment: "汤头清亮适合清淡党，午市人多。",
  },
  {
    id: "rk6",
    rank: 6,
    name: "深夜炭烤生蚝档",
    category: "烧烤夜宵",
    price: "¥55",
    score: 4.4,
    trend: "up",
    comment: "生蚝当日到货，凌晨前来最稳。",
  },
];